<template>
  <a-modal
    :title="$t('title.inboundComplete')"
    :centered="true"
    :visible="visible"
    width="40%"
    :destroyOnClose="destroyOnClose"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item :label="$t('business.label.containerNo')">
          <span>{{ view.container.no }}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.sourceLocation')">
          <span>{{ view.sourceLocation.no }}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.targetStorageRoom')">
          <vxe-input v-model="storageRoom.name" @click="searchStorageRoom()"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.targetLocation')">
          <vxe-input v-model="view.targetLocation.no" @click="searchLocation()"/>
        </a-descriptions-item>
      </a-descriptions>
      <storage-room-modal ref="storageRoomModal" @change="selectStorageRoom" />
      <location-modal ref="locationModal" @change="selectLocation" />
    </a-spin>
  </a-modal>
</template>
<script>
import { post } from '@/api/Api'
import { ContainerFactoryView } from '@/api/dto/view/ContainerFactoryView'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Location } from '@/api/dto/common/Location'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import Api from '@/api'

export default {
  name: 'InboundComplete',
  components: { LocationModal, StorageRoomModal },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      destroyOnClose: true,
      view: new ContainerFactoryView(),
      storageRoom: new StorageRoom(),
      loading: false
    }
  },
  methods: {
    open(args) {
      if (args) {
        this.view.container = args.container
        if (args.sourceLocation) {
          this.view.sourceLocation = args.sourceLocation
        }
        if (args.targetLocation) {
          this.view.targetLocation = args.targetLocation
        }
        this.visible = true
      }
    },
    handleOk() {
      this.confirmLoading = true
      let args = {
        'container.no': this.view.container.no,
        'location.no': this.view.targetLocation.no
      }
      post(Api.containerPutaway, {type:'generalHandler'},args).then(res => {
        if (res.success) {
          this.$emit('success')
          let that = this
          this.$success({
            title: '入库上架成功',
            onOk() {
              that.handleCancel()
            },
            okText: '确定',
            centered: true
          })
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    handleCancel() {
      this.visible = false
    },
    searchStorageRoom() {
       this.$refs.storageRoomModal.open()
    },
    selectStorageRoom(sr) {
      if (sr.length > 0) {
        this.storageRoom = Object.assign(new StorageRoom(), sr[0])
      } else {
        this.storageRoom = new StorageRoom()
      }
      this.view.targetLocation = new Location()
    },
    searchLocation(){
      if (this.storageRoom.name === ''|| this.storageRoom.name === undefined || this.storageRoom.name === null){
        return this.$warning({
          title: '目的库房为空',
          content: '请选择目的库房',
          centered: true,
          okText: '确定'
        })
      }
      this.$refs.locationModal.open({'storageRoom.name': this.storageRoom.name})
    },
    selectLocation(loc) {
      if (loc.length > 0) {
        this.view.targetLocation = Object.assign(new Location(), loc[0])
      } else {
        this.view.targetLocation = new Location()
      }
    }
  }
}
</script>